import * as API from '@/api';

export const actions = {
  // R: 取得藝品文章列表
  async getArtworks({ commit }, data) {
    const params = {
      ...data,
      limit: 6
    }
    const list = await API.GET('/artworks', params);

    // 濾掉下架的文章
    list.data.data = list.data.data.filter((artwork) => artwork.is_on === 1);

    commit('setArtworks', list.data);
  },

  // R: 取得一篇藝品文章
  async getArtWork({ commit }, articleId) {
    const artwork = await API.GET(`/artworks/${articleId}`);

    if (!artwork.data.tags) {
      artwork.data.tags = [];
    }

    commit('setArtwork', artwork.data);
  },
};
